import {
  modalResolveReportSubTitle,
  modalResolveReportTitle,
} from "_constants/Modal";
import { Divider } from "primereact/divider";

export const ModalResolveReportHeader = () => {
  return (
    <>
      <h4 className="header-title margin-bottom-4">
        {modalResolveReportTitle}
      </h4>
      <span className="text-base-regular">{modalResolveReportSubTitle}</span>
      <Divider className="margin-top-12 margin-bottom-0" />
    </>
  );
};
